import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect } from 'react';
import { getConstrainedView, MapBounds } from '../../util/MapBounds';

interface GoogleMapBoundsProps {
  bounds: MapBounds;
}

/** Opt-in child of GoogleMapElement that eases the map back inside the given bounds after each move. */
const GoogleMapBounds: React.FC<GoogleMapBoundsProps> = ({ bounds }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    let correcting = false;

    // 'idle' fires after initial load and after every pan/zoom/keyboard move settles.
    const listener = map.addListener('idle', () => {
      // Skip the idle caused by our own correction to avoid rounding-driven loops.
      if (correcting) {
        correcting = false;
        return;
      }
      const center = map.getCenter();
      const zoom = map.getZoom();
      if (!center || zoom === undefined) return;

      const target = getConstrainedView(
        { center: { lat: center.lat(), lng: center.lng() }, zoom },
        bounds
      );
      if (!target) return;

      correcting = true;
      if (target.zoom !== zoom) map.setZoom(target.zoom);
      map.panTo(target.center);
    });

    return () => listener.remove();
  }, [map, bounds]);

  return null;
};

export default GoogleMapBounds;
